module.exports = __webpack_public_path__ + "img/CAN.d61d94f3.svg";